import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    paddingBottom: spacing(5) - 2,
    marginBottom: spacing(5),
    marginTop: spacing(5),
  },
  label: {
    color: colors.text.secondary,
    marginBottom: spacing(1),
  },
  box: {
    marginTop: spacing(1),
  },
  boxChannel: {
    width: '100%',
  },
  icon: {
    marginRight: spacing(1),
    opacity: 0.7,
    '& svg': {
      width: `${spacing(6)}px !important;`,
      height: `${spacing(6)}px !important;`,
    },
  },
  editButton: {
    lineHeight: 0,
    marginLeft: spacing(4),
  },
  channel: {
    marginBottom: spacing(3),
    position: 'relative',
  },
  channelName: {
    display: 'flex',
  },
  hint: {
    marginBottom: spacing(4) - 4,
  },
  actionsBlock: {
    display: 'flex',
  },
});

export default styles;
